import { render, staticRenderFns } from "./ChallengesHeader.vue?vue&type=template&id=2458c1ef"
import script from "./ChallengesHeader.vue?vue&type=script&lang=js"
export * from "./ChallengesHeader.vue?vue&type=script&lang=js"
import style0 from "./ChallengesHeader.vue?vue&type=style&index=0&id=2458c1ef&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports